import React, { Component, useState, useRef, useEffect, useCallback, useContext } from 'react';

import { useTranslation } from 'react-i18next';
import '../99_untils/i18n/';
// import SEOHelmet from '../99_untils/SEOHelmet';
import {
    // Navigate,
    useNavigate,
    useSearchParams
} from 'react-router-dom';
import {
    Button, Container, Row, Col,
    // Card, CardBody, CardTitle, CardSubtitle, CardText 
} from 'reactstrap';

// Import the initialized services from your config file
import { auth, db } from '../99_untils/firebase/';
import {
    signInWithCustomToken
} from "firebase/auth";
// import UserAuthContext from "../99_untils/firebase/UserAuthContext";
import AuthTokenContext from "../99_untils/AuthTokenContext";

// import useSound from 'use-sound';

import apiURLs from '../99_untils/apiURLs';

import AppNavi from '../Navigation/Navigation';

import './MiniGame.css';

import ShareLink from '../99_untils/ShareLink';





import minaPoseIdol01 from './images/idol_Mina/Mina_1.png';
import minaPoseIdol02 from './images/idol_Mina/Mina_2.png';
import minaPoseIdol03 from './images/idol_Mina/Mina_3.png';
import minaPoseIdol04 from './images/idol_Mina/Mina_4.png';
import minaPoseIdol05 from './images/idol_Mina/Mina_5.png';
import minaPoseIdol06 from './images/idol_Mina/Mina_6.png';
import minaPoseIdol07 from './images/idol_Mina/Mina_7.png';



import BPPoseIdol01 from './images/idol_BP/blackpink_01.png';
import BPPoseIdol02 from './images/idol_BP/blackpink_02.png';
import BPPoseIdol03 from './images/idol_BP/blackpink_03.png';
import BPPoseIdol04 from './images/idol_BP/blackpink_04.png';
import BPPoseIdol05 from './images/idol_BP/blackpink_05.png';
import BPPoseIdol06 from './images/idol_BP/blackpink_06.png';
import BPPoseIdol07 from './images/idol_BP/blackpink_07.png';
import BPPoseIdol08 from './images/idol_BP/blackpink_08.png';


import jenniePoseIdol01 from './images/idol_jennie/jennie_01.png';
import jenniePoseIdol02 from './images/idol_jennie/jennie_02.png';
import jenniePoseIdol03 from './images/idol_jennie/jennie_03.png';
import jenniePoseIdol04 from './images/idol_jennie/jennie_04.png';
import jenniePoseIdol05 from './images/idol_jennie/jennie_05.png';
import jenniePoseIdol06 from './images/idol_jennie/jennie_06.png';
import jenniePoseIdol07 from './images/idol_jennie/jennie_07.png';
import jenniePoseIdol08 from './images/idol_jennie/jennie_08.png';
import jenniePoseIdol09 from './images/idol_jennie/jennie_09.png';


import jisooPoseIdol01 from './images/idol_jisoo/jisoo_01.png';
import jisooPoseIdol02 from './images/idol_jisoo/jisoo_02.png';
import jisooPoseIdol03 from './images/idol_jisoo/jisoo_03.png';
import jisooPoseIdol04 from './images/idol_jisoo/jisoo_04.png';
import jisooPoseIdol05 from './images/idol_jisoo/jisoo_05.png';
import jisooPoseIdol06 from './images/idol_jisoo/jisoo_06.png';
import jisooPoseIdol07 from './images/idol_jisoo/jisoo_07.png';
import jisooPoseIdol08 from './images/idol_jisoo/jisoo_08.png';


import lisaPoseIdol01 from './images/idol_lisa/lisa_01.png';
import lisaPoseIdol02 from './images/idol_lisa/lisa_02.png';
import lisaPoseIdol03 from './images/idol_lisa/lisa_03.png';
import lisaPoseIdol04 from './images/idol_lisa/lisa_04.png';
import lisaPoseIdol05 from './images/idol_lisa/lisa_05.png';
import lisaPoseIdol06 from './images/idol_lisa/lisa_06.png';
import lisaPoseIdol07 from './images/idol_lisa/lisa_07.png';
import lisaPoseIdol08 from './images/idol_lisa/lisa_08.png';


import rosePoseIdol01 from './images/idol_rose/rose_01.png';
import rosePoseIdol02 from './images/idol_rose/rose_02.png';
import rosePoseIdol03 from './images/idol_rose/rose_03.png';
import rosePoseIdol04 from './images/idol_rose/rose_04.png';



import rankNum01 from './images/rank_nums/rank_nums_01.png';
import rankNum02 from './images/rank_nums/rank_nums_02.png';
import rankNum03 from './images/rank_nums/rank_nums_03.png';
import rankNum04 from './images/rank_nums/rank_nums_04.png';
import rankNum05 from './images/rank_nums/rank_nums_05.png';
// import rankNum06 from './images/rank_nums/rank_nums_06.png';
// import rankNum07 from './images/rank_nums/rank_nums_07.png';
// import rankNum08 from './images/rank_nums/rank_nums_08.png';
// import rankNum09 from './images/rank_nums/rank_nums_09.png';

import stageSpotlight from './images/minigame-spotlights.png';

// import idolIconMina from './images/idol_icons/idol_icon_Mina.png';
// import idolIconChaeyoung from './images/idol_icons/idol_icon_Chaeyoung.png';
// import idolIconDahyun from './images/idol_icons/idol_icon_Dahyun.png';
// import idolIconJeongyeon from './images/idol_icons/idol_icon_Jeongyeon.png';
// import idolIconJihyo from './images/idol_icons/idol_icon_Jihyo.png';
// import idolIconMomo from './images/idol_icons/idol_icon_Momo.png';
// import idolIconNayeon from './images/idol_icons/idol_icon_Nayeon.png';
// import idolIconSana from './images/idol_icons/idol_icon_Sana.png';
// import idolIconTzuyu from './images/idol_icons/idol_icon_Tzuyu.png';

import idolIconBP from './images/idol_icons/idol_icon_blackpink.jpg';
import idolIconLisa from './images/idol_icons/idol_icon_lisa.jpg';
import idolIconJisoo from './images/idol_icons/idol_icon_jisoo.jpg';
import idolIconRose from './images/idol_icons/idol_icon_rose.jpg';
import idolIconJennie from './images/idol_icons/idol_icon_jennie.jpg';



import IconMusicWht from './IconMusicWht';
import IconMusic from './IconMusic';


// import clickSound from './sounds/pop-331049.mp3';
// import clickSound from './sounds/pop-331049-shortened.mp3';
// import clickSound from './sounds/pop-331049-shortened2.mp3';
// import clickSoundSrc from './sounds/pop-331049-shortened2.mp3';
// import clickSoundSrc from './sounds/pop-331049.mp3';


export default function MiniGamePlay(tarIdolProfile) {
    // props tarIdolProfile,
    // console.log("MiniGamePlay constructor started ")
    const isMountedRef = useRef();
    const canvasRef = useRef();
    // const navRef = useRef();
    const rankRef = useRef();
    const titleScoreWrapRef = useRef();
    const idolNameRef = useRef('');
    const bgImgWrapRef = useRef();
    const bgImgTaxiWrapRef = useRef();
    const positionRef = useRef(0); // Store background position
    const positionTaxiRef = useRef(0); // Store background position

    // Sound playback only via useSound

    // const [playSoundInstant] = useSound(clickSoundSrc, {
    //     playbackRate: 0.75,
    //     interrupt: true
    // });



    const { t } = useTranslation();

    const { i18n } = useTranslation();
    let curLang = i18n.language;
    const navigate = useNavigate();

    // Auth state
    const [authToken, setAuthToken] = useState(null);
    //   const [isAuthChecked, setIsAuthChecked] = useState(false);
    //   const [authError, setAuthError] = useState(null);
    const authTimeoutRef = useRef(null);

    // Configurable timeout in milliseconds (default 3 seconds)
    const AUTH_TIMEOUT = 3000;
    const [userAuth, setUserAuth] = useState(window.authTokenData || null);
    const passAuthTempRef = useRef(true);
    const userAuthRef = useRef(window.authTokenData || null);
    const authEventHandlerRef = useRef(null);
    //       const dutyCheckContext = useContext(DutyCheckContext);
    //   const [dutyOnStatus, setDutyOnStatus] = useState(dutyCheckContext || true);

    const [searchParams, setSearchParams] = useSearchParams();
    // To get a specific query parameter:
    const idIdolSelected = searchParams.get("id"); // e.g., for URL like /path?id=123
    // console.log('MiniGamePlay idIdolSelected = ' + idIdolSelected);

    // Use state to manage the queue of promises
    const [queue, setQueue] = useState(Promise.resolve());
    const [status, setStatus] = useState('Idle');

    const [gameStatus, setGameStatus] = useState(0);



    // const [idolSelected, setIdolSelected] = useState(people[idSelected]);
    // const [idolClickCount, setIdolClickCount] = useState(Number(idolSelected.score));
    // const [userClickCount, setUserClickCount] = useState(0);
    // const [addUpClickCount, setAddUpClickCount] = useState(idolClickCount + userClickCount);
    let updateCountFirstTime = false;
    const [idolSelected, setIdolSelected] = useState(null);
    const [idolClickCount, setIdolClickCount] = useState(0);
    const [userClickCount, setUserClickCount] = useState(0);
    const [addUpClickCount, setAddUpClickCount] = useState(0);


    const [dancerPoses, setDancerPoses] = useState(
        [
            minaPoseIdol01, minaPoseIdol02, minaPoseIdol03,
            minaPoseIdol04, minaPoseIdol05, minaPoseIdol06,
            minaPoseIdol07
        ]
    );


    const [BPPoses, setBPPoses] = useState(
        [
            BPPoseIdol01, BPPoseIdol02, BPPoseIdol03,
            BPPoseIdol04, BPPoseIdol05, BPPoseIdol06,
            BPPoseIdol07, BPPoseIdol08
        ]
    );


    const [jenniePoses, setJenniePoses] = useState(
        [
            jenniePoseIdol01, jenniePoseIdol02, jenniePoseIdol03,
            jenniePoseIdol04, jenniePoseIdol05, jenniePoseIdol06,
            jenniePoseIdol07, jenniePoseIdol08, jenniePoseIdol09
        ]
    );



    const [jisooPoses, setJisooPoses] = useState(
        [
            jisooPoseIdol01, jisooPoseIdol02, jisooPoseIdol03,
            jisooPoseIdol04, jisooPoseIdol05, jisooPoseIdol06,
            jisooPoseIdol07, jisooPoseIdol08
        ]
    );



    const [lisaPoses, setLisaPoses] = useState(
        [
            lisaPoseIdol01, lisaPoseIdol02, lisaPoseIdol03,
            lisaPoseIdol04, lisaPoseIdol05, lisaPoseIdol06,
            lisaPoseIdol07, lisaPoseIdol08
        ]
    );



    const [rosePoses, setRosePoses] = useState(
        [
            rosePoseIdol01, rosePoseIdol02, rosePoseIdol03,
            rosePoseIdol04
        ]
    );


    const [rankNumImg, setRankNumImg] = useState(
        [
            rankNum01, rankNum02, rankNum03, rankNum04, rankNum05,
            // rankNum06, rankNum07, rankNum08, rankNum09
        ]
    );

    const [idolNameZh, setIdolNameZh] = useState([
        '娜璉',
        'Momo',
        'Mina',
        '彩瑛',
        '定延',
        '子瑜',
        '志效',
        'Sana',
        '多賢',
    ]);
    const [tolalPose, setTolalPose] = useState(0);
    const [currentPose, setCurrentPose] = useState(0);

    const [initialDataLoaded, setInitialDataLoaded] = useState(false);
    const [miniGameLeaderData, setMiniGameLeaderData] = useState();

    let selectedIdolData = null

    let idolSelectedID = useRef();// = '';

    let idolName4Chars = '';


    // console.log("MiniGamePlay idolSelected = ")
    // console.log(idolSelected)


    var targetWidth = window.innerWidth;
    var targetHeight = window.innerHeight;


    const formatNumber = (num) => {
        if (num === null || num === undefined) return num;

        // Use 'en-US' locale for standard K, M, B suffixes.
        // 'notation: "compact"' enables the abbreviation.
        // 'maximumFractionDigits: 1' limits the decimal places.
        return new Intl.NumberFormat('en-US', {
            notation: 'compact',
            maximumFractionDigits: 1
        }).format(num);
    };

    const formatNumberWithCommas = (num) => {
        if (num === null || num === undefined) return num;

        // Convert to string and add commas every 3 digits
        return new Intl.NumberFormat('en-US').format(num);
    };


    // A generic async function to handle the POST request
    const sendPostRequest = async (url, data, token) => {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // 'Authorization': `Bearer ${userAuthRef.current.token && userAuthRef.current.token}`,
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        // console.log('Minigameplay sendPostRequest to URL:', url);
        // console.log('Minigameplay sendPostRequest to data:', data);
        // console.log('Minigameplay sendPostRequest to token only:', token);
        // ...(userAuth ? { 'Authorization': `Bearer ${userAuth}` } : {})
        // ...(userAuthRef.current.token ? { 'Authorization': `Bearer ${userAuthRef.current.token}` } : {})
        // ...(userAuthRef.current ? { 'Authorization': `Bearer ${userAuthRef.current.token}` } : {})
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();

    };

    // const addToQueue = (data) => {
    const addToQueue = (tarIdolID) => {
        // setStatus(`Adding request for ${data.title}`);
        setStatus(`Adding request for new ${tarIdolID}vote`);

        // console.log('Successfully posted tarIdolID:', tarIdolID);

        // console.log('Successfully posted userAuth:', userAuth);

        const dataClickCount = {
            "votes": userClickCount
        };


        // let responseData = 'abc123xyz';
        // let responseData = userAuthContext;
        // const userAccessToken = JSON.stringify(responseData); // No auth token in this flow
        // const userAccessToken = JSON.stringify(responseData.customToken); // No auth token in this flow

        // console.log('MiniGamePlay addToQueue userAccessToken = ');
        // console.log(userAccessToken);

        if (window.authTokenData) {

            // console.log('MiniGamePlay addToQueue postTwiceGameVotingDataURL = ');
            // console.log(`${apiURLs.postTwiceGameVotingDataURL}${tarIdolID}`);

            const newRequestPromise = sendPostRequest(
                `${apiURLs.postTwiceGameVotingDataURL}${tarIdolID}`,
                dataClickCount,
                window.authTokenData
            )
                .then(response => {
                    // console.log('Successfully posted:', response.title);
                })
                .catch(error => {
                    // console.error('Error in queue:', error.message);
                });

            // Chain the new request to the existing queue
            setQueue(currentQueue => currentQueue.finally(() => newRequestPromise));
        } else {
            // console.error('Error in queue: missing userAuthRef.current');
        }


        // // Chain the new request to the existing queue
        // setQueue(currentQueue => currentQueue.finally(() => newRequestPromise));
    };


    const backBtnOnClick = () => {
        // setIdolSelected(false)
        // setIdolNameFocus(0)
        // console.log('playBtnOnClick + idolSelected = '+idolSelected)
        // console.log('playBtnOnClick')
        navigate(`/${curLang}/minigameselect`)
        // useNavigate('/:lang/minigameselect')
    }
    // ...existing code...

    const animateBackgroundStatic = () => {
        if (bgImgWrapRef.current) {



            // Calculate speed based on user progress for dynamic effect
            //   let speed = Math.max(5, countDisplayRef.current * 0.5);
            //   if (speed > 15) speed = 15; // Cap maximum speed
            // let speed = 15;
            let speedTaxi = 35;

            // Update position once per click
            // positionRef.current -= speed;
            positionTaxiRef.current -= speedTaxi;

            // Apply the position update
            // bgImgWrapRef.current.style.backgroundPosition = `${positionRef.current}px bottom`;
            bgImgTaxiWrapRef.current.style.backgroundPosition = `${positionTaxiRef.current}px bottom`;

            // console.log('Animation update - position:', positionRef.current, 'speed:', speed);

            // Reset position if it goes too far to create a seamless loop
            // if (positionRef.current <= -666) {
            //     positionRef.current = 0;
            // }
            if (positionTaxiRef.current <= -1332) {
                positionTaxiRef.current = 0;
            }

            // Clear the animation ID since this is a single update
            //   animationIdRef.current = null;
        }
    }

    // Handle click/key press
    const handleClickDance = () => {

        // console.log('MiniGamePlay clicked')

        // playSound();
        // audioRef.current.play();
        // playSound();
        // playSoundInstant();

        // animateBackgroundStatic();

        setUserClickCount(userClickCount + 1);
        // const clickCount = localClickCount+1;

        let adjustClickCount = userClickCount + 1;
        let updateAddUpCount = idolClickCount + adjustClickCount;

        setAddUpClickCount(updateAddUpCount)

        const tempPosCal = (currentPose + 1) % tolalPose;
        setCurrentPose(tempPosCal)

        // console.log('MiniGamePlay addToQueue called');
        // console.log(sortedLeaderByScore[idIdolSelected].memberId);
        // console.log(sortedLeaderByScore[idIdolSelected]);
        // console.log(idolSelectedID.current);

        addToQueue(idolSelectedID.current);
        // setStatus('Processing queue...');
    }

    /**
   * Validates the auth token by calling the leaderboard API
   * @param {string} token - The auth token to validate
   * @returns {Promise<boolean>} - Returns true if validation succeeds
   */
    /*
      const validateAuthToken = async (token) => {
          console.log('Home validateAuthToken called with token:', token ? 'present' : 'missing');
  
          try {
              const response = await fetch(apiURLs.getLeaderboardDataURL, {
                  method: 'GET',
                  headers: {
                      'Authorization': `Bearer ${token}`,
                      'Content-Type': 'application/json'
                  }
              });
  
              console.log('Home validateAuthToken response status:', response.status);
  
              // Check if response is successful (2xx status codes)
              if (response.ok) {
                  console.log('Home validateAuthToken - Auth token validated successfully');
                  return true;
              } else {
                  console.error('Home validateAuthToken - API returned error status:', response.status);
                  return false;
              }
          } catch (error) {
              console.error('Home validateAuthToken - Error validating token:', error);
              return false;
          }
      };
  
      const handleAuthentication = async () => {
          // console.log('Minigameplay handleAuthentication started');
  
          // Listen for auth token from mobile app webview
          const handleAuthTokenEvent = async (event) => {
              //   console.log('Minigameplay handleAuthTokenEvent - Token received from mobile app');
              //   console.log('Minigameplay handleAuthTokenEvent - event.detail.token');
              //   console.log(event.detail.token);
  
              const token = event.detail.token;
  
              if (authTimeoutRef.current) {
                  clearTimeout(authTimeoutRef.current);
                  authTimeoutRef.current = null;
              }
  
              setAuthToken(token);
  
              // Validate token by calling leaderboard API
              const isValid = await validateAuthToken(token);
  
              if (isValid) {
                  // console.log('Home handleAuthTokenEvent - Token is valid, showing page');
                  userAuthRef.current = { token: token, validated: true };
                  // setIsAuthChecked(true);
                  // setAuthError(null);
  
                  // Remove loading mask
                  // setTimeout(() => {
                  //   fakeLoadMaskOut();
                  // }, animationDuration);
              } else {
                  // console.error('Home handleAuthTokenEvent - Token validation failed');
                  // setAuthError('validation_failed');
                  // setIsAuthChecked(true);
                  userAuthRef.current = null;
  
                  // Show error message
                  // setTimeout(() => {
                  //   fakeLoadMaskOut();
                  // }, animationDuration);
              }
          };
  
          // Store handler reference for cleanup
          authEventHandlerRef.current = handleAuthTokenEvent;
  
  
          // console.log('Minigameplay handleAuthentication window.addEventListener authTokenReceived');
          // Add event listener for token from mobile app
          window.addEventListener('authTokenReceived', handleAuthTokenEvent);
  
          // Check if token was already received before component mounted
          if (window.authTokenReceived && window.authTokenData) {
              // if (window.authTokenData) {
              //   console.log('Minigameplay handleAuthentication - Token already present, using it');
              handleAuthTokenEvent({ detail: { token: window.authTokenData } });
              return;
          }
  
          // Set timeout - if no token received within AUTH_TIMEOUT, show error
          // authTimeoutRef.current = setTimeout(() => {
          // //   console.log('Minigameplay handleAuthentication - Timeout waiting for auth token');
          //   setAuthError('timeout');
          //   setIsAuthChecked(true);
          //   userAuthRef.current = null;
  
          //   // Show error message
          //   setTimeout(() => {
          //     fakeLoadMaskOut();
          //   }, animationDuration);
          // }, AUTH_TIMEOUT);
  
          // console.log(`Minigameplay handleAuthentication - Waiting for token (timeout: ${AUTH_TIMEOUT}ms)`);
      };
      */

    // ...existing code...


    useEffect(() => {
        isMountedRef.current = true;
        if (window.authTokenData) {
            userAuthRef.current = window.authTokenData;
        }
        const fetchData = async () => {
            try {
                const response = await fetch(apiURLs.getLeaderboardDataURL, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        ...(window.authTokenData ? { 'Authorization': `Bearer ${window.authTokenData}` } : {})
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                if (isMountedRef.current) {
                    const sortedLeaderByScore = [...result.entries].sort((a, b) => b.score - a.score);
                    setMiniGameLeaderData(sortedLeaderByScore);
                    if (!updateCountFirstTime) {
                        updateCountFirstTime = true;
                        const idIdolSelected = String(searchParams.get("id"));
                        const findMemberByID = (leaderboardData, memberID) => leaderboardData.find(member => member.memberId === memberID);
                        selectedIdolData = findMemberByID(sortedLeaderByScore, idIdolSelected);
                        if (!selectedIdolData) return;
                        idolSelectedID.current = selectedIdolData.memberId;
                        idolName4Chars = String(selectedIdolData.memberId).slice(0, 4);
                        idolNameRef.current = idolName4Chars;
                        if (idolName4Chars === 'lisa') {
                            setDancerPoses(lisaPoses)
                            setTolalPose(lisaPoses.length - 1);
                        } else if (idolName4Chars === 'rose') {
                            setDancerPoses(rosePoses)
                            setTolalPose(rosePoses.length - 1);
                        } else if (idolName4Chars === 'jenn') {
                            setDancerPoses(jenniePoses)
                            setTolalPose(jenniePoses.length - 1);
                        } else if (idolName4Chars === 'jiso') {
                            setDancerPoses(jisooPoses)
                            setTolalPose(jisooPoses.length - 1);
                        } else {
                            setDancerPoses(BPPoses)
                            setTolalPose(BPPoses.length - 1);
                        }
                        setIdolSelected(selectedIdolData);
                        setIdolClickCount(Number(selectedIdolData.score));
                        setUserClickCount(0);
                        setAddUpClickCount(Number(selectedIdolData.score));
                    }
                }
            } catch (error) {
                //   setError(error);
            } finally {
                //   setLoading(false);
            }
        };
        fetchData();
        const intervalIdAni = setInterval(animateBackgroundStatic, 500);
        return () => {
            clearInterval(intervalIdAni);
            isMountedRef.current = false;
        };
    }, []);



    return (
        <>
            <div className='mini-game-select-play-wrap'>

                {/* ...existing code... */}
                {/* <SEOHelmet 
                      titleKey="metaTitleMiniGamePlay" 
                      descriptionKey="metaDescriptionMiniGamePlay" 
                      canonicalPath={`/${curLang}/minigame`}
                  /> */}
                {/* <AppNavi colorWhiteLogo={true} bgWhiteConfig={true} /> */}

                <div className="mini-game-idol-dance-bg-wrap" ref={bgImgWrapRef}>

                </div>
                <div className='mini-game-idol-dance-bg-spotlight'>
                    <img className="" src={stageSpotlight} />
                </div>
                <div className="mini-game-idol-dance-bg-taxi-wrap" ref={bgImgTaxiWrapRef}></div>
                <div ref={rankRef} className="mini-game-play-rank-list-wrap">
                    <ul className="mini-game-play-rank-list-ul">

                        {// if data fetch trued
                            miniGameLeaderData &&
                            miniGameLeaderData.map((person, index) => (
                                <li key={index}>
                                    <div className='profile-pic'>
                                        {/* <img src={person.image} alt={person.name} loading="lazy" /> */}
                                        {/* import idolIconBP from './images/idol_icons/idol_icon_blackpink.jpg';
import idolIconLisa from './images/idol_icons/idol_icon_lisa.jpg';
import idolIconJisoo from './images/idol_icons/idol_icon_jisoo.jpg';
import idolIconRose from './images/idol_icons/idol_icon_rose.jpg';
import idolIconJennie from './images/idol_icons/idol_icon_jennie.jpg'; */}
                                        <img src={(() => {
                                            const namePrefix = person.memberId ? String(person.memberId).slice(0, 4) : '';
                                            switch (namePrefix) {
                                                case 'lisa': return idolIconLisa;
                                                case 'rose': return idolIconRose;
                                                case 'jenn': return idolIconJennie;
                                                case 'jiso': return idolIconJisoo;
                                                default: return idolIconBP; // Fallback to Blackpink
                                            }
                                        })()} alt={person.name || 'Member'} />
                                        {/* <h5>{index}</h5> */}
                                        <div className='profile-pic-rank'><img src={rankNumImg[index]} alt={'Rank ' + index} loading="lazy" /></div>
                                    </div>
                                    <div>
                                        {curLang === 'zh-HK' ?
                                            idolNameZh[(() => {
                                                const namePrefix = person.memberId ? String(person.memberId).slice(0, 4) : '';
                                                switch (namePrefix) {
                                                    // switch (String(miniGameLeaderData[idolNameFocus] && 
                                                    //     miniGameLeaderData[idolNameFocus].name).slice(0, 2)) {
                                                    case 'lisa': return 1;
                                                    case 'rose': return 2;
                                                    case 'jenn': return 3;
                                                    case 'jiso': return 4;
                                                    default: return 0; // Fallback to Blackpink
                                                }
                                            })()]
                                            :
                                            person.memberId.toUpperCase()
                                        }

                                    </div>
                                    <div>
                                        {formatNumber(person.score)}
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                </div>
                <div className='corner-paper minigame-play'></div>
                <div ref={titleScoreWrapRef} className="mini-game-play-title-score-wrap">
                    <Container>
                        <Row className=''>
                            <Col className="">

                                {// if data fetch trued
                                    miniGameLeaderData &&
                                    <>
                                        <h5 className='margin-bot-10'>
                                            <IconMusicWht sizelg={true} />
                                            {formatNumberWithCommas(addUpClickCount)}
                                        </h5>
                                        <h1 className='color-text-pink'>
                                            {
                                                curLang === 'zh-HK' ?
                                                    idolNameZh[(() => {
                                                        const namePrefix = idolNameRef.current;
                                                        // console.log('namePrefix = ' + namePrefix)
                                                        switch (namePrefix) {
                                                            case 'lisa': return 1;
                                                            case 'rose': return 2;
                                                            case 'jenn': return 3;
                                                            case 'jiso': return 4;
                                                            default: return 0; // Fallback to Mina
                                                        }
                                                    })()]
                                                    :
                                                    idolSelectedID.current.toUpperCase()

                                            }
                                        </h1>
                                        {/* {console.log('idolSelectedID.current = ' + idolSelectedID.current)} */}
                                    </>
                                }
                            </Col>
                        </Row>
                    </Container>
                </div>

                <div className='mini-game-idol-dance-btn-stats-wrap'>
                    {/* <Button className="mini-game-idol-dance-wrap-btn w-100"
                        onClick={() => { handleClickDance() }}> */}
                    <div
                        // className='mini-game-idol-dance-wrap-imgs mx-auto d-block'
                        className={`${idolNameRef.current == 'grou' ?
                            'mini-game-idol-dance-wrap-imgs BP mx-auto d-block' :
                            'mini-game-idol-dance-wrap-imgs mx-auto d-block'}`}
                    >

                        {/* <div className='mini-game-idol-dance-wrap-imgs mx-auto d-block'> */}
                        {/* className={`${phoneLengthError || phoneInvalidError ? 'LD-input LD-input-red-border' : 'LD-input'}`} */}
                        {// if data fetch trued
                            dancerPoses &&
                            tolalPose > 0 &&
                            dancerPoses.map((pose, index) => (

                                currentPose == index &&
                                <img key={index} className="img-full-width" src={dancerPoses[index]} />

                            ))
                        }

                        <div className='mini-game-idol-dance-overlay-btn'
                            onClick={() => { handleClickDance() }}>
                        </div>
                    </div>

                    {/* <div className=''> */}
                    <div className='mini-game-idol-dance-wrap-imgs-hidden'>


                        {// if data fetch trued
                            dancerPoses &&
                            tolalPose > 0 &&
                            dancerPoses.map((pose, index) => (
                                <img key={index} className="img-full-width" src={pose} loading="lazy" />
                            ))
                        }

                    </div>
                    {/* </Button> */}

                    <div className='mini-game-idol-dance-wrap-btn-stats'>
                        <Container>
                            <Row className=''>
                                <Col className="">

                                    {userClickCount == 0 ?
                                        <p className='mini-game-idol-dance-wrap-btn-stats-title margin-bot-10'>
                                            {t('miniGameTitleClickPlay')}</p>
                                        :
                                        <p className='mini-game-idol-dance-wrap-btn-stats-title margin-bot-10'>
                                            <IconMusicWht />
                                            +{userClickCount}
                                        </p>}

                                    <Button size="lg" className='blink-completed w-100' title='Back'
                                        disabled={userClickCount == 0}
                                        onClick={() => {
                                            // navigate(`/${curLang}/minigameselect`)
                                            // addToQueue(idolSelectedID.current);
                                            setGameStatus(1);
                                        }}>
                                        {t('miniGameBtnComplete')}
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>
            {
                // open a overlay content when gameStatus == 1
                gameStatus == 1 &&
                <div className="mini-game-idol-dance-complete-wrap">
                    {/* <div className="mini-game-idol-dance-complete-mask"></div> */}
                    <div className="d-flex justify-content-center align-items-center vh-100">

                        <Container fluid>
                            <Row className='g-0'>
                                <Col md={{ offset: 3, size: 6 }}
                                    className="mx-auto text-center">
                                    <img className="mini-game-idol-dance-complete-idol-img" src={dancerPoses[0]} loading="lazy" />
                                    <div className="mini-game-idol-dance-complete-content-wrap">
                                        <div className="margin-bot-30">

                                            <h5 className="color-text-pink margin-bot-10">{t('miniGameCompleteTitle')}</h5>
                                            <p className='color-text-pink'>{t('miniGameCompleteContent')}</p>

                                        </div>
                                        <div className="margin-bot-30">

                                            <h5 className="margin-bot-10 color-text-white"><span className=" margin-none"><IconMusicWht sizeXL={true} /></span>+{userClickCount}</h5>
                                            <p className='color-text-white'>{t('miniGameCompleteContentTotal')} {formatNumberWithCommas(addUpClickCount)}</p>

                                        </div>

                                        <div className="margin-bot-10">
                                            <Button size="lg"
                                                className={`
                                            blink
                                            w-100
                                            text-align-center
                                            `}
                                                title='Back'
                                                onClick={() => {
                                                    // clickToProceed()
                                                    navigate(`/${curLang}`)
                                                }}
                                            >
                                                <div>{t('miniGameBtnGotIt')}</div>
                                            </Button>
                                        </div>

                                        <Container>
                                            <Row className=''>
                                                <Col className="text-center color-text-white">
                                                    <ShareLink
                                                        title={t('taxiGameIntroShareLink')}
                                                        text={t('taxiGameIntroShareText')}
                                                        url={'https://l.d-ash.com/qcej3'}
                                                    // url={window.location.href} 
                                                    />
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            }
        </>
    );

}

